import React from 'react';
import { RefreshCw } from 'lucide-react';
import { PRICE_LABEL } from '../lib/commercialCopy';

interface Props {
    onUpdate: () => void;
}

/**
 * Surfaced on the paid report when the estate has been edited since purchase.
 * The existing report remains visible below — we only prompt for a refresh,
 * we don't lock the user out of what they already paid for.
 */
export const ReportOutdatedBanner: React.FC<Props> = ({ onUpdate }) => (
    <div className="rounded border border-[#E8D89A] bg-[#FAF3E0] p-4 flex items-start gap-3">
        <div className="flex-1 min-w-0">
            <h3 className="font-serif text-[18px] font-medium text-[#1A1A1A] m-0">
                This report is based on a previous version of your inputs
            </h3>
            <p className="text-[13px] text-[#7A5A00] mt-2 leading-relaxed">
                You've edited the estate since this report was generated. The figures
                below reflect your answers at the time of purchase. Refresh the report
                to regenerate it with your latest inputs.
            </p>
            <button
                onClick={onUpdate}
                className="mt-3 inline-flex items-center gap-1.5 bg-[#3730A3] hover:bg-[#2E2780] text-white text-[13px] font-medium tracking-[0.02em] px-5 py-3 rounded transition-colors"
            >
                <RefreshCw className="w-3.5 h-3.5" />
                Update report ({PRICE_LABEL})
            </button>
        </div>
    </div>
);
